import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';
import {
    ThirdPartyPayoff,
    ThirdPartyPayoffDocumentKind,
} from '../../../../models/FlowOfFunds/flow-of-funds.model';

export interface DeleteThirdPartyPayoffSupportingDocumentRequest {
    engagementId: number;
    tableRowId: number;
    documentKind: ThirdPartyPayoffDocumentKind;
}

export const DeleteThirdPartyPayoffSupportingDocument = createAsyncThunk(
    'flowOfFunds/deleteThirdPartyPayoffSupportingDocument',
    async (
        params: DeleteThirdPartyPayoffSupportingDocumentRequest,
        dispatch: any
    ) => {
        const axios = dispatch.getState().core.axios;

        try {
            const response = await axios.delete(
                `/api/flowOfFunds/${params.engagementId}/thirdPartyPayoffs/rows/${params.tableRowId}/documents/${params.documentKind}`
            );

            if (response.status !== 200) {
                throw new Error('Failed to delete the supporting document');
            }

            return response.data as ThirdPartyPayoff;
        } catch (error) {
            createNotification(
                'Could not delete the supporting document.',
                'error'
            );
            throw error;
        }
    }
);
